import React from "react";
import { Star, Quote, ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../data";

export const Reviews = () => (
  <section
    id="reviews"
    data-testid="reviews-section"
    className="relative py-24 md:py-32 scroll-mt-20 overflow-hidden"
  >
    <div aria-hidden className="absolute left-1/2 -translate-x-1/2 top-0 w-[40rem] h-[40rem] rounded-full bg-neon/10 blur-[140px]" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <div className="glass rounded-[2rem] p-8 sm:p-12 md:p-16 grid lg:grid-cols-2 gap-12 items-center border-white/10">
        <div>
          <Reveal>
            <p className="mb-5 inline-flex items-center gap-2 text-xs sm:text-sm tracking-[0.2em] uppercase font-bold text-neon">
              <span className="h-px w-8 bg-neon" /> 03 — Reviews
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="flex items-end gap-4" data-testid="reviews-count">
              <span className="font-display font-black text-6xl md:text-7xl tracking-tighter text-white">
                {BUSINESS.reviews}
              </span>
              <span className="mb-2 text-white/60 text-lg">Google reviews</span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-4 flex items-center gap-1" aria-label="Highly rated">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={22} className="text-neon fill-neon" />
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              MEGAWIN5K is trusted by thousands of visitors across Jakarta. See what
              the community is saying, or share your own experience.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <a
              href={BUSINESS.reviewsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-cta-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-neon text-black font-bold px-8 py-4 hover:shadow-[0_0_30px_rgba(0,240,255,0.6)] transition-shadow duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
            >
              View & Leave a Review <ExternalLink size={16} />
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div
            data-testid="review-highlight"
            className="relative rounded-3xl p-8 md:p-10 bg-gradient-to-br from-white/[0.06] to-transparent border border-white/10"
          >
            <Quote size={40} className="text-neon/40" />
            <p className="mt-4 font-display font-bold text-2xl md:text-3xl tracking-tight text-white leading-snug">
              “goods movement”
            </p>
            <p className="mt-4 text-sm text-white/50">
              — Highlighted from Google reviews
            </p>
            <div className="mt-8 pt-6 border-t border-white/10 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-neon/20 flex items-center justify-center">
                <Star size={18} className="text-neon fill-neon" />
              </div>
              <p className="text-sm text-white/60">
                Rated by <span className="text-white font-semibold">{BUSINESS.reviews}</span> visitors on Google
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
